import React, { useState } from "react";
import Dialog from "@components/Dialog";
import SizedBox from "@components/SizedBox";
import { observer } from "mobx-react-lite";
import { useLang } from "@src/hooks/useLang";
import Button from "@components/Button";
import { Row } from "@src/components/Flex";
import Text from "@components/Text";
import Loading from "@components/Loading";

interface IProps {
  visible: boolean;
  seasonName?: string;
  onClose?: () => void;
  onSubmit?: () => Promise<void> | void;
}

const DeleteSeasonDialog: React.FC<IProps> = ({ onSubmit, seasonName, ...rest }) => {
  const lang = useLang();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (onSubmit) await onSubmit();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog style={{ width: 408 }} title={lang.seasons.deleteDialogTitle} {...rest}>
      {seasonName && (
        <>
          <Text type="heading" size={15} color="#494C5B">
            {seasonName}
          </Text>
          <SizedBox height={8} />
        </>
      )}
      <Text size={15} color="#899093" style={{ width: 320 }}>
        {lang.seasons.deleteConfirm}
      </Text>
      <SizedBox height={24} />
      <Row>
        <Button kind="outline" onClick={handleSubmit}>
          {!loading ? lang.seasons.deleteButton : <Loading />}
        </Button>
        <SizedBox width={16} />
        <Button onClick={rest.onClose}>
          {lang.seasons.cancelButton}
        </Button>
      </Row>
    </Dialog>
  );
};

export default observer(DeleteSeasonDialog);
